// extracted by mini-css-extract-plugin
export default {"container":"container_container__UUJsT","form":"container_form__lnG5+","title":"container_title__YX5Nj","input":"container_input__H6TdA","button":"container_button__VfRkY"};